module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "interviews"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.$t('categories.interviews'),
      "level": 2,
      "font": "astonished",
      "color": "red"
    }
  }), _vm._v(" "), _c('list', {
    ref: "list",
    attrs: {
      "scroll": true,
      "items": _vm.interviews,
      "link": "interview",
      "fields": ['band', 'date', 'author'],
      "type": "img"
    },
    on: {
      "update": _vm.load
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fe3862d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/Interviews.vue
// module id = 258
// module chunks = 0